import React, { useState } from 'react';
import {
  Box, IconButton, Slide, Snackbar,
} from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';
import {
  FacebookShareButton, FacebookMessengerIcon, LineShareButton, LineIcon,
} from 'react-share';
import { Link } from 'react-router-dom';
import config from '@/configs/config';

export default ({
  backgroundUrl,
  iniviteUrl,
  iniviteMessage,
  isLogin,
  onShareButtonClick,
}) => {
  const [isSnackerbarOpen, setIsSnackerbarOpen] = useState(false);
  const [snakerbarKey, setSnakerbarKey] = useState();
  return (
    <Box display="flex" flexDirection="column">
      <Box flexGrow={1}>
        <img
          src={backgroundUrl}
          alt=""
          width="100%"
        />
      </Box>
      <Box
        alignItems="center"
        bgcolor="black"
        color="white"
        display="flex"
        flexDirection="column"
        fontWeight="bold"
        justifyContent="center"
        py={2}
      >
        {!isLogin
          ? (
            <Link
              className="loginButton"
              style={{
                fontSize: '16px',
                fontWeight: 'bold',
                height: 'auto',
                margin: 0,
                padding: '4px 16px',
                textAlign: 'center',
                width: 'auto',
                display: 'block',
              }}
              to={{
                pathname: '/register',
                state: {
                  afterLoginUrl: window.location.pathname + window.location.search,
                },
              }}
            >
              登入參加活動
            </Link>
          )
          : (
            <>
              <Box>
                分享連結邀請好友加入
                {config.BrandNameTW}
              </Box>
              <Box mt={1} display="flex" alignItems="center">
                <LineShareButton
                  onClick={onShareButtonClick}
                  style={{ height: 32 }}
                  url={iniviteUrl}
                >
                  <LineIcon size={32} round />
                </LineShareButton>
                <FacebookShareButton
                  onClick={onShareButtonClick}
                  style={{ height: 32, marginLeft: 8 }}
                  url={iniviteUrl}
                >
                  <FacebookMessengerIcon size={32} round />
                </FacebookShareButton>
                <IconButton
                  onClick={() => {
                    setIsSnackerbarOpen(true);
                    setSnakerbarKey(+new Date());
                    const content = document.getElementById('textArea');

                    content.value = [iniviteMessage, iniviteUrl].join('\n');
                    content.select();
                    document.execCommand('copy');

                    onShareButtonClick();
                  }}
                  style={{
                    backgroundColor: 'white',
                    height: 32,
                    marginLeft: 8,
                    padding: 0,
                    width: 32,
                  }}
                >
                  <LinkIcon />
                </IconButton>
                <Snackbar
                  key={snakerbarKey}
                  open={isSnackerbarOpen}
                  onClose={() => {
                    setIsSnackerbarOpen(false);
                  }}
                  TransitionComponent={(props) => <Slide {...props} direction="up" />}
                  message="複製連結成功"
                />
              </Box>
            </>
          )}
        <textarea
          id="textArea"
          style={{
            height: 0, width: 0, position: 'absolute', top: -10,
          }}
        />
      </Box>
    </Box>
  );
};
